import React from 'react';

const RelatorioClientes = () => {
  return (
    <div>
      <h2>Relatório de Clientes</h2>
      <p>Aqui você pode implementar o relatório de clientes.</p>
    </div>
  );
};

export default RelatorioClientes;
